import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Accountsgroup, AccountsgroupTypeData } from '../../../interfaces/masters/accountsgroup';
import { AccountsgroupApi } from '../api/accountsgroup.api';

@Injectable()

export class AccountsgroupService  extends AccountsgroupTypeData{

  constructor( private api:AccountsgroupApi) {
    super();
   }

   list(url: string): Observable<Accountsgroup[]> {
    return this.api.list(url);
  }
  
  getById(url:string): Observable<Accountsgroup>{
      return this.api.getById(url);
  }
  
  create(url: string, data:Accountsgroup): Observable<Accountsgroup> {
    return this.api.add(url,data);
  }
  
  update(url: string, data:Accountsgroup): Observable<Accountsgroup> {
    return this.api.update(url,data);
  }
    
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
  
  getall(url: string): Observable<any> {
    return this.api.getall(url);
  }
}

